var map = {
	"./1.webp": 73913,
	"./2.webp": 8636,
	"./3.webp": 10175,
	"./4.webp": 41186,
	"./5.webp": 87853,
	"./6.webp": 44768,
	"./hand.webp": 83403
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91418;